import React from "react";
import ExpensesList from "./Components/ExpensesList";

const App: React.FC = () => {
  return (
    <ExpensesList></ExpensesList>
  );
};

export default App;
